import {
  RESET_DFSP_HUB_CSRS,
  SET_DFSP_HUB_CSRS_CERTIFICATES_ERROR,
  SET_DFSP_HUB_CSRS_CERTIFICATES,
  SHOW_DFSP_HUB_CSRS_CERTIFICATE_MODAL,
  HIDE_DFSP_HUB_CSRS_CERTIFICATE_MODAL,
  SUBMIT_DFSP_HUB_CSRS_CERTIFICATE,
  AUTOGENERATE_DFSP_HUB_CSRS_CERTIFICATE,
  REQUEST_DFSP_HUB_CSRS_CERTIFICATES,
  DOWNLOAD_DFSP_HUB_CSRS_CERTIFICATE,
  ResetDfspHubCsrsAction,
  SetDfspHubCsrsCertificatesErrorAction,
  SetDfspHubCsrsCertificatesAction,
  ShowDfspHubCsrsCertificateModalAction,
  HideDfspHubCsrsCertificateModalAction,
  SubmitDfspHubCsrsCertificateAction,
  AutogenerateDfspHubCsrsCertificateAction,
  RequestDfspHubCsrCertificatesAction,
  DownloadDfspHubCsrsCertificateAction,
} from './types';
import { CSR } from '../types';

export function resetDfspHubCsrs(): ResetDfspHubCsrsAction {
  return {
    type: RESET_DFSP_HUB_CSRS,
  };
}
export function setDfspHubCsrsCertificatesError({
  error,
}: {
  error: string;
}): SetDfspHubCsrsCertificatesErrorAction {
  return {
    type: SET_DFSP_HUB_CSRS_CERTIFICATES_ERROR,
    error,
  };
}
export function setDfspHubCsrsCertificates({
  certificates,
}: {
  certificates: CSR[];
}): SetDfspHubCsrsCertificatesAction {
  return {
    type: SET_DFSP_HUB_CSRS_CERTIFICATES,
    certificates,
  };
}
export function showDfspHubCsrsCertificateModal({
  certificate,
  title,
}: {
  certificate: string;
  title: string;
}): ShowDfspHubCsrsCertificateModalAction {
  return {
    type: SHOW_DFSP_HUB_CSRS_CERTIFICATE_MODAL,
    certificate,
    title,
  };
}
export function hideDfspHubCsrsCertificateModal(): HideDfspHubCsrsCertificateModalAction {
  return {
    type: HIDE_DFSP_HUB_CSRS_CERTIFICATE_MODAL,
  };
}

export function requestDfspHubCsrsCertificates(): RequestDfspHubCsrCertificatesAction {
  return {
    type: REQUEST_DFSP_HUB_CSRS_CERTIFICATES,
  };
}

export function submitDfspHubCsrsCertificate({
  enrollmentId,
}: {
  enrollmentId: number;
}): SubmitDfspHubCsrsCertificateAction {
  return {
    type: SUBMIT_DFSP_HUB_CSRS_CERTIFICATE,
    enrollmentId,
  };
}

export function autogenerateDfspHubCsrsCertificate({
  enrollmentId,
}: {
  enrollmentId: number;
}): AutogenerateDfspHubCsrsCertificateAction {
  return {
    type: AUTOGENERATE_DFSP_HUB_CSRS_CERTIFICATE,
    enrollmentId,
  };
}

export function downloadDfspHubCsrsCertificate({
  certificate,
  cn,
  extension,
}: {
  certificate: string;
  cn: string;
  extension: string;
}): DownloadDfspHubCsrsCertificateAction {
  return {
    type: DOWNLOAD_DFSP_HUB_CSRS_CERTIFICATE,
    certificate,
    cn,
    extension,
  };
}
